import { type ReferralCode } from "../types";

export function getLatestReferralCode(referralCodes?: ReferralCode[]) {
  if (!referralCodes || referralCodes.length === 0) {
    return undefined;
  }

  const [latestReferralCodeItem] = referralCodes.slice(-1);
  return latestReferralCodeItem.referralCode;
}
